<template>
   <!-- :style="{ height: bodyHeight + 'px', overflow: 'hidden' }" -->
  <div id="app">
    <!-- 8602155489600970752 只在山西专区展示 -->
    <Header v-if="$route.meta.showHeader && $store.state.homeID == '8602155489600970752'" />
    <!-- keep-alive用于缓存  exclude用于取消缓存-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="aa"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="aa"></router-view>
    <TabBar v-show="$route.meta.showTabbar" />
  </div>
</template>
<script>
// import { requireShare } from './utils/share'
import TabBar from './components/TabBar'
import Header from './components/Header'
import { getAppid } from '@/utils/public'
import { mapState, mapActions } from 'vuex'
import { messageQuery } from '@/api/getData'
import { isIOS } from '@/utils/index.js'
import { requireConfig } from '@/utils/share.js'
import { getRequest } from '@/utils/public'
export default {
  name: 'App',
  components: {
    TabBar,
    Header
  },
  data() {
    return {
      bodyHeight: '',
    }
  },
  created() {
    let url = window.location.href;
    let arg = getRequest(url);
    if (arg.arrondiId !== undefined ) {
       localStorage.setItem('homeID', arg.arrondiId)
      this.$store.state.homeID = arg.arrondiId || localStorage.getItem('homeID')
    }
    this.storeInfo()
  },
  mounted() {
    let  current_url = window.location.href;
    let hostname = window.location.hostname
    if(hostname == 'study.81lianpin.com'){ // 正式
      let  target_url = current_url.replace("https://study.81lianpin.com","https://learn.81lianpin.com");
      window.location = target_url;
      // http://studyone.81lianpin.com  第二个备用链接
      return
    }
    // this.$store.state.homeID = localStorage.getItem('homeID')
    this.bodyHeight = document.documentElement.clientHeight
    if(isIOS()) {
      requireConfig()
    }
  },
  computed: {
  },
  methods: {
     ...mapActions(['storeInfo']),
  }
}
</script>

<style lang="scss">
@import "./assets/styles/unifyColor.scss";
@import "./assets/styles/global.scss";
#app {
  color: #000;
  height: 100vh;
  overflow: hidden;
}
body {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.aa{
  position: static !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue